import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { registerPwa } from "./pwa";
import "./styles.css";
import "./terms.css";
import "./performance.css";
import "./class-switcher.css";
import "./admin-record-export.css";
import "./record-import.css";
import "./ui-refinements.css";
import "./calendar-holidays.css";
import "./class-setup-status.css";

registerPwa();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
